"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.resetPropType = exports.pricePropType = exports.linkPropType = exports.labelPropType = exports.filteringOptionPropType = exports.filterPropType = exports["default"] = exports.buzzTilePropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var linkPropType = _propTypes["default"].shape({
  url: _propTypes["default"].string,
  openNewTab: _propTypes["default"].bool
});

exports.linkPropType = linkPropType;

var buzzTilePropType = _propTypes["default"].shape({
  date: _propTypes["default"].string,
  contentType: _propTypes["default"].shape({
    label: _propTypes["default"].String
  }),
  heading: _propTypes["default"].string,
  tileLayout: _propTypes["default"].string,
  link: linkPropType
});

exports.buzzTilePropType = buzzTilePropType;

var labelPropType = _propTypes["default"].shape({
  title: _propTypes["default"].string,
  text: _propTypes["default"].string
});

exports.labelPropType = labelPropType;

var pricePropType = _propTypes["default"].shape({
  label: _propTypes["default"].string,
  value: _propTypes["default"].number,
  displayValue: _propTypes["default"].string
});

exports.pricePropType = pricePropType;

var filteringOptionPropType = _propTypes["default"].shape({
  label: _propTypes["default"].string,
  price: pricePropType,
  type: _propTypes["default"].string,
  id: _propTypes["default"].string,
  titleAndText: labelPropType,
  selected: _propTypes["default"]["boolean"]
});

exports.filteringOptionPropType = filteringOptionPropType;

var resetPropType = _propTypes["default"].shape({
  url: _propTypes["default"].string,
  prioirity: _propTypes["default"].string,
  label: _propTypes["default"].string
});

exports.resetPropType = resetPropType;

var filterPropType = _propTypes["default"].shape({
  label: _propTypes["default"].string,
  filteringOptions: _propTypes["default"].arrayOf(filteringOptionPropType)
});

exports.filterPropType = filterPropType;

var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  label: labelPropType,
  notes: labelPropType,
  resetLabel: _propTypes["default"].string,
  filters: _propTypes["default"].arrayOf(filterPropType)
});

var _default = PROP_TYPES;
exports["default"] = _default;